import React from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import ValuePropositionSection from './ValuePropositionSection';
import SocialProofSection from './SocialProofSection';
import ExecutiveDashboardSection from './ExecutiveDashboardSection';
import FeaturesSection from './FeaturesSection';
import IntegrationSection from './IntegrationSection';
import TestimonialSection from './TestimonialSection';
import FAQSection from './FAQSection';
import ComplianceFooter from './ComplianceFooter';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ProblemSection />
      <ValuePropositionSection />
      <SocialProofSection />
      <ExecutiveDashboardSection />
      <FeaturesSection />
      <IntegrationSection />
      <TestimonialSection />
      <FAQSection />
      <ComplianceFooter />
      <Footer />
    </div>
  );
};

export default LandingPage;